export default function registerRenderOn($) {
  //become available when device match
  //used on <textarea>HTML Codes</textarea>
  $.registerDirective("render-on", {
    value: "", //mobile or pc

    bind() {
      this.value = this.exp;
      if (
        (this.value === "mobile" && $(window).width() <= 768) ||
        (this.value === "pc" && $(window).width() > 768)
      ) {
        this.layout();
      }
    },

    layout() {
      this.el.replaceWith($(this.el[0].textContent));
    },
  });
}
